var _defs, _path, _rect, _circle, _path2, _path3, _path4, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWiFiOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.94 36.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .wifi_off__cls-1 {\n        fill: none;\n        stroke: #B1B1B1;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wifi_off__cls-1",
    d: "M7.85,7.98c-2.43,1.2-4.65,2.8-6.56,4.74M35.65,12.72c-2.25-2.28-4.93-4.1-7.88-5.34-4.79-2.01-10.07-2.4-15.05-1.17"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "wifi_off__cls-1",
    x: 18.45,
    y: 30.03,
    width: 0.03,
    height: 0.03
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "wifi_off__cls-1",
    cx: 18.45,
    cy: 30.03,
    r: 1.29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "wifi_off__cls-1",
    d: "M22.29,22.89c-3-1.63-6.84-1.2-9.41,1.31-.04.04-.09.09-.13.13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "wifi_off__cls-1",
    d: "M20.33,13.83c3.62.42,7.01,2.07,9.59,4.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "wifi_off__cls-1",
    d: "M7.02,18.53c1.86-1.89,4.14-3.27,6.62-4.06"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "wifi_off__cls-1",
    x1: 3.92,
    y1: 4.56,
    x2: 32.92,
    y2: 33.55
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiFiOff);
export default __webpack_public_path__ + "static/media/WiFi_off.cef35d524c85e99353084bb57b4dcc06.svg";
export { ForwardRef as ReactComponent };